import { render, staticRenderFns } from "./my_course.vue?vue&type=template&id=ddbddb5e&scoped=true"
import script from "./my_course.vue?vue&type=script&lang=js"
export * from "./my_course.vue?vue&type=script&lang=js"
import style0 from "./my_course.vue?vue&type=style&index=0&id=ddbddb5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbddb5e",
  null
  
)

export default component.exports